import styled from 'styled-components';

export const FormStyles = styled.form`
  padding: 1rem;
  display: grid;
`;

export const styles = {
  textField: {
    margin: '0.5rem 0',
    fontSize: '10px',
  },
  input: {
    background: '#F7F8FA',
  },
  sectionHeader: {
    marginBottom: '0.5rem',
  },
  button: {
    padding: '14px 35px',
  },
  saveButtonLabel: {
    color: '#009688',
  },
  saveFinishButtonLabel: {
    color: '#fff',
  },
  helperText: {
    fontSize: '12px',
    fontStyle: 'italic',
  },
  temporaryLedgerLabelContainer: {
    display: 'inline-flex',
    alignItems: 'flex-start',
    columnGap: '8px',
    margin: '0',
  },
  temporaryLedgerTooltip: {
    paddingBottom: '6px',
    fill: 'gray',
  },
  removeMargin: {
    margin: '0',
  },
  categoryRadioGroup: {
    height: '170px',
    width: 'fit-content',
  },
  categoryRadioControl: {
    alignItems: 'center',
  },
  labelSpacer: {
    paddingBottom: '15px',
  },
};
